"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import AuthWrapper from "src/components/AuthWrapper";
import { AuthProvider } from "src/contexts/AuthContext";
import { useLayoutBodyBackground } from "src/hooks/usePageBodyBackground";

const unprotectedRoutes = ["/", "/login", "/auth/callback", "/support", "/privacy", "/pricing"];

const queryClient = new QueryClient();

const Providers = ({ children }: { children: React.ReactNode }) => {
  // Set black background for root layout
  useLayoutBodyBackground('black');
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AuthWrapper unprotectedRoutes={unprotectedRoutes}>
          {children}
        </AuthWrapper>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default Providers;
